import './App.css';
import { Login } from './components';

function App() {
  return (
    <div>
      <Login/>
  </div>
  );
}

export default App;
